import React from "react"
import Typography from "@mui/material/Typography"
import { useInfoStore } from "../store/userInfo";
import { Box, Button, Dialog } from "@mui/material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { isBrowser } from 'react-device-detect';
import { useOrderStore } from "../store/order";
import { useMenuStore } from "../store/menuState";
import { useWindowDimensions } from "../App";
var packageJson = require('../../package.json')

const SignOut = (props: { openSignOut: any; setOpenSignOut: any; }) => {
  const { openSignOut, setOpenSignOut } = props;
  const { logout } = useInfoStore();
  const { resetOrderCart } = useOrderStore();
  const { resetMenu } = useMenuStore();
  const navigate: NavigateFunction = useNavigate();
  const { orientation } = useWindowDimensions()
  const landMode = (orientation === "landscape") ?true: false

  const handleClose = () => setOpenSignOut(false)
  const handleSignOut = () => {
    // 1. 먼저 네이티브에 로그아웃 메시지 전송
    postLogoutMessage();
    
    // 2. 모든 스토어 완전 리셋
    resetOrderCart();     // 주문/카트 데이터 리셋
    resetMenu();          // 메뉴/타이머 데이터 리셋
    logout();             // 사용자 정보 리셋
    
    // 3. 네이티브 데이터 삭제 완료를 기다린 후 페이지 전환
    setTimeout(() => {
      navigate("/userlogin");
    }, 100); // 100ms 대기로 네이티브 처리 시간 확보
  }

  // const handleOpenApp = () => {
  //   if(!isBrowser){
  //     if(window.ReactNativeWebView !== undefined)
  //       window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'openApp'}));
  //     else if(window.Android !== undefined)
  //       window.Android.postMessage(JSON.stringify({'type': 'openApp'}));
  //   }
  //   setOpenSignOut(false)
  // }

  // 로그아웃되었을 때 네이티브로 메세지 전송
  const postLogoutMessage = () => {

    if(!isBrowser){
      if(window.ReactNativeWebView !== undefined)
        window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'logout'}));
      else if(window.Android !== undefined)
        window.Android.postMessage(JSON.stringify({'type': 'logout'}));
    }
  }

  return (
    <Box>
      <Dialog open={openSignOut} PaperProps={{ sx :{justifyContent: 'center', alignItems: 'center', height: '36.0rem', padding: '4rem', borderRadius: '1.5rem'} }} >
        <Box sx={{padding: '7.5rem 6,0rem', justifyContent: 'center', alignItems: 'center', overflow: 'hidden'}}>
          <Box sx={{ justifyContent: 'center', gap: '1.0rem', alignItems: 'center'}}>
            <Typography sx={{fontSize: '4.0rem', fontWeight: '700', fontStyle: 'normal', textAlign: 'center', textTransform: 'none', textWrap: 'nowrap'}}>Log out</Typography>
            {/* <Typography sx={{fontSize: '24px', fontWeight: '300', fontStyle: 'normal', textAlign: 'center'}}>Please, Wait</Typography> */}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: landMode? 'row': 'column', justifyContent: 'center', alignItems: 'center', gap: '10px', flexShrink: 0, mt: '4.9rem'}}>
            <Button onClick={() => handleClose()} sx={{width: '20.0rem', height: '5.0rem', padding: '.5rem 2.0rem', borderRadius: '2.5rem', background: '#999'}}>
              <Typography sx={{color: '#fff', fontSize: '2.4rem', fontWeight: '700', fontStyle: 'normal'}} >Cancel</Typography>
            </Button>
            <Button onClick={() => handleSignOut()} sx={{width: '20.0rem', height: '5.0rem', padding: '.5rem 2.0rem', borderRadius: '2.5rem', background: '#DA291C'}}>
              <Typography sx={{color: '#fff', fontSize: '2.4rem', fontWeight: '700', fontStyle: 'normal'}} >Log out</Typography>
            </Button>
          </Box>
        </Box>
        <Box sx={{position: 'absolute', right: '.5rem', bottom: '.5rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <Box sx={{width: '100%', borderRadius: '.3rem', backgroundColor: '#EDEDED', padding: {md: '.3rem .6rem', lg: '.3rem .9rem'}}}>
            <Typography sx={{textAlign: 'center', color: '#000', fontSize: '1.2rem', fontWeight: '500'}}>ver {packageJson.version}</Typography>
          </Box>
          {/* <Box sx={{background: '#f5f5f5', padding: '15px 20px', borderRadius: '5px', }} 
            onClick={() => handleOpenApp()}>
            <Typography sx={{textAlign: 'center', color: '#000', fontWeight: '600'}}>Move to Download</Typography>
          </Box> */}
        </Box>
      </Dialog>
    </Box>
  )
}

export default SignOut
